export const typography = {
    sizes: {
        xl: "28px",
        lg: "18px",
        md: "16px",
        sm: "14px",
        xs: "12px"
    }
};